import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes, Navigate, useMatch } from 'react-router-dom';
import Login from './Login';
import AuthCode from './AuthCode';
import Authorized from './Authorized';
var Mobile = function () {
    var match = useMatch('/mobile');
    if (match) {
        return _jsx(Navigate, { to: "/mobile/login" });
    }
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "authorized/*", element: _jsx(Authorized, {}) }), _jsx(Route, { path: "login", element: _jsx(Login, {}) }), _jsx(Route, { path: "authCode", element: _jsx(AuthCode, {}) })] }));
};
export default Mobile;
